var map = {
	"./DrLubhani/ChangeColor": [
		780,
		188
	],
	"./Ganga/ChangeColor": [
		782,
		195
	],
	"./Indus/ChangeColor": [
		784,
		209
	],
	"./Kabini/ChangeColor": [
		786,
		217
	],
	"./Kaveri/ChangeColor": [
		694,
		21
	],
	"./Luni/ChangeColor": [
		788,
		224
	],
	"./Narmada/ChangeColor": [
		790,
		228
	],
	"./Nethravathi/ChangeColor": [
		792,
		236
	],
	"./Neyyar/ChangeColor": [
		794,
		241
	],
	"./Periyar/ChangeColor": [
		796,
		245
	],
	"./SAANVI/ChangeColor": [
		798,
		256
	],
	"./Sabarmathi/ChangeColor": [
		800,
		264
	],
	"./Sparsh/ChangeColor": [
		802,
		271
	],
	"./Sutlej/ChangeColor": [
		804,
		276
	],
	"./Yamuna/ChangeColor": [
		806,
		283
	],
	"./pamba/ChangeColor": [
		808,
		293
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 2074;
module.exports = webpackAsyncContext;